import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { SCOCartComponent } from './sco-cart/sco-cart.component';
import { GUIBaseModule } from '../gui-base/gui-base.module';
import { ElvisDSModule } from 'ngx-elvis-ds';

@NgModule({
  declarations: [
    SCOCartComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    GUIBaseModule,
    ElvisDSModule
  ],
  exports: [
    SCOCartComponent,
  ]
})
export class GUIScoModule { }
